module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "sec_front"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap2line"
  }, [_vm._v("I")]), _vm._v("n the preparation of this book I would like to thank all those who have offered advice and support, all those who have helped me with my research. I am indebted to Mr John Franklin for his guidance, advice and provision of some research materials. Furthermore, I must also thank M. Yves Martin, Mr Ian J. Smith, John Lubomski and Sally Fairweather for their generous assistance with, and photographing of, archival material at the Archives Nationales and Service Historique de la Défence Armée du Térre, in Paris.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I must single out Ian Smith for his friendship, dedicated support to the project and excellent company during our numerous research trips to Paris. His advice and guidance during our many thousands of hours of conversation over numerous bottles of red wine was, and is, of immense help in understanding the wealth of data that we have gathered, to synthesise it into a cohesive narrative. Without this most generous support by Ian the book would have taken far longer to complete.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Erwin Muilwijk deserves a special word of praise, without his assistance in the provision of Dutch - Belgian source material this book could never have come to fruition. Lieutenant-Colonel Timmermans must be thanked for illustrations. I heartily encourage visitors to his excellent website "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://Napoléon-monuments.eu/.",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("http://Napoléon-monuments.eu/.")])])]), _vm._v(" Sally Fairweather must be thanked for proof reading this text.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a290636","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Acknowledgements.vue
// module id = 69
// module chunks = 0